import { createRouter, createWebHistory } from 'vue-router'
import { isFlutterApp } from '@/utils/flutter-bridge'
import { closeIdentityPopup, handOverIdentityReturn, pickIdentityQuery } from '@/utils/identity-popup'
import { fetchMe } from '@/api/auth'
import { hasDealerAppraisalFlow } from '@/utils/dealer-appraisal-session'
import { hasAccessToken, JOIN_ROUTES_BACK_BLOCK_KEY } from '@/utils/auth-storage'

const base = import.meta.env.BASE_URL || '/'

const routes = [
  {
    path: '/',
    // redirect: () => (hasAccessToken() ? '/home' : '/intro')
    redirect: () => (hasAccessToken() ? '/home' : '/login')
  },

  {
    path: '/intro',
    name: 'Intro',
    component: () => import('@/views/IntroPage.vue'),
    meta: { title: 'Intro', hideBottomTab: true }
  },

  // 인트로 미리보기 - 로그인으로 넘어가지 않는다. 새로고침하면 다시 돈다.
  {
    path: '/intro-preview',
    name: 'IntroPreview',
    component: () => import('@/views/IntroPreviewPage.vue'),
    meta: { title: 'Intro 미리보기', hideBottomTab: true }
  },

  // 페이지 링크 (퍼블리싱 목록)
  {
    path: '/pages_link',
    name: 'PagesLink',
    component: () => import('@/views/PagesLinkPage.vue'),
    meta: { title: '페이지 목록', hideBottomTab: true }
  },

  // 00. 로그인 · 회원가입
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginPage.vue'),
    meta: { title: '로그인', hideBottomTab: true }
  },
  {
    path: '/login/sns/:providerType',
    name: 'SnsCallback',
    component: () => import('@/views/SnsCallbackPage.vue'),
    meta: { title: 'SNS 로그인', hideBottomTab: true }
  },
  {
    path: '/join/step1',
    name: 'JoinStep1',
    component: () => import('@/views/JoinStep1Page.vue'),
    meta: { title: '회원가입', hideBottomTab: true }
  },
  {
    path: '/join/step2',
    name: 'JoinStep2',
    component: () => import('@/views/JoinStep2Page.vue'),
    meta: { title: '회원가입', hideBottomTab: true }
  },
  {
    path: '/join/step3',
    name: 'JoinStep3',
    component: () => import('@/views/JoinStep3Page.vue'),
    meta: { title: '회원가입', hideBottomTab: true }
  },
  {
    path: '/join/recommended-branch',
    name: 'JoinRecommendedBranch',
    component: () => import('@/views/JoinRecommendedBranchPage.vue'),
    meta: { title: '추천지점 선택', hideBottomTab: true }
  },
  {
    path: '/join/complete',
    name: 'JoinComplete',
    component: () => import('@/views/JoinCompletePage.vue'),
    meta: { title: '가입완료', hideBottomTab: true }
  },

  // 01. 홈
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
    meta: { title: '홈' }
  },
  // 호가거래: API 연동 화면(Figma 01_홈 금/은). 예전 /home1·/home2 는 리다이렉트만 유지.
  {
    path: '/home/gold',
    name: 'HomeGold',
    component: () => import('@/views/HomeGoldPage.vue'),
    meta: { title: '호가거래' }
  },
  {
    path: '/home/silver',
    name: 'HomeSilver',
    component: () => import('@/views/HomeSilverPage.vue'),
    meta: { title: '호가거래' }
  },
  {
    path: '/home1',
    name: 'Home1',
    redirect: '/home/gold'
  },
  {
    path: '/home2',
    name: 'Home2',
    redirect: '/home/silver'
  },
  {
    path: '/home/home1',
    name: 'Home1Legacy',
    redirect: '/home/gold'
  },
  {
    path: '/home/home2',
    name: 'Home2Legacy',
    redirect: '/home/silver'
  },
  {
    path: '/home/gold/complete',
    name: 'HomeGoldComplete',
    component: () => import('@/views/P2PAskComplete.vue'),
    meta: { title: '거래 완료' }
  },
  {
    path: '/home/silver/complete',
    name: 'HomeSilverComplete',
    component: () => import('@/views/P2PAskComplete.vue'),
    meta: { title: '거래 완료' }
  },

  // 02. 프로필 · VVIP
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/ProfilePage.vue'),
    meta: { title: '프로필' }
  },
  {
    path: '/vvip',
    name: 'VvipService',
    component: () => import('@/views/VvipServicePage.vue'),
    meta: { title: 'VVIP 서비스' }
  },
  {
    path: '/vvip/service',
    name: 'VvipService02',
    component: () => import('@/views/VvipService02Page.vue'),
    meta: { title: 'VVIP 서비스' }
  },

  // 02. 실물 자산 감정
  {
    path: '/appraisal/step1',
    name: 'AppraisalStep1',
    component: () => import('@/views/AppraisalStep1Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step2-1',
    name: 'AppraisalStep2_1',
    component: () => import('@/views/AppraisalStep2_1Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step2-2',
    name: 'AppraisalStep2_2',
    component: () => import('@/views/AppraisalStep2_2Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step2-3',
    name: 'AppraisalStep2_3',
    component: () => import('@/views/AppraisalStep2_3Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step2-4',
    name: 'AppraisalStep2_4',
    component: () => import('@/views/AppraisalResultPage.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step3-1',
    name: 'AppraisalStep3_1',
    component: () => import('@/views/AppraisalStep3_1Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step3-2',
    name: 'AppraisalStep3_2',
    component: () => import('@/views/AppraisalStep3_2Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step3-3',
    name: 'AppraisalStep3_3',
    component: () => import('@/views/AppraisalStep3_3Page.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/step3-4',
    name: 'AppraisalStep3_4',
    component: () => import('@/views/AppraisalResultPage.vue'),
    meta: { title: '실물 자산 감정' }
  },
  {
    path: '/appraisal/result',
    name: 'AppraisalResult',
    component: () => import('@/views/AppraisalResultPage.vue'),
    meta: { title: '실물 자산 감정' }
  },

  // 03. 구매
  {
    path: '/buy/step1',
    name: 'BuyStep1',
    component: () => import('@/views/BuyStep1Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/step2',
    name: 'BuyStep2',
    component: () => import('@/views/BuyStep2Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/step3-1',
    name: 'BuyStep3_1',
    component: () => import('@/views/BuyStep3_1Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/step3-2',
    name: 'BuyStep3_2',
    component: () => import('@/views/BuyStep3_2Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/step4',
    name: 'BuyStep4',
    component: () => import('@/views/BuyStep4Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/step5',
    name: 'BuyStep5',
    component: () => import('@/views/BuyStep5Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/step5-2',
    name: 'BuyStep5_2',
    component: () => import('@/views/BuyStep5_2Page.vue'),
    meta: { title: '구매' }
  },
  {
    path: '/buy/asset',
    name: 'BuyAsset',
    component: () => import('@/views/BuyAssetPage.vue'),
    meta: { title: '자산 구매하기' }
  },
  {
    path: '/buy/step7',
    name: 'BuyStep7',
    component: () => import('@/views/BuyStep7Page.vue'),
    meta: { title: '구매' }
  },

  // 04. 판매
  {
    path: '/sell/step1',
    name: 'SellStep1',
    component: () => import('@/views/SellStep1Page.vue'),
    meta: { title: '판매' }
  },
  {
    path: '/sell/step2',
    name: 'SellStep2',
    component: () => import('@/views/SellStep2Page.vue'),
    meta: { title: '판매' }
  },
  {
    path: '/sell/step3',
    name: 'SellStep3',
    component: () => import('@/views/SellStep3Page.vue'),
    meta: { title: '판매' }
  },
  {
    path: '/sell/complete02',
    name: 'SellComplete02',
    component: () => import('@/views/P2PAskComplete.vue'),
    meta: { title: '거래 완료' }
  },

  // 05. 지점 감정
  {
    path: '/dealer-appraisal/step1',
    name: 'DealerAppraisalStep1',
    component: () => import('@/views/DealerAppraisalStep1Page.vue'),
    meta: { title: '지점 감정' }
  },
  {
    path: '/dealer-appraisal/step2',
    name: 'DealerAppraisalStep2',
    component: () => import('@/views/DealerAppraisalStep2Page.vue'),
    meta: { title: '지점 감정' }
  },
  {
    path: '/dealer-appraisal/step3',
    name: 'DealerAppraisalStep3',
    component: () => import('@/views/DealerAppraisalStep3Page.vue'),
    meta: { title: '지점 감정' }
  },
  {
    path: '/dealer-appraisal/step4',
    name: 'DealerAppraisalStep4',
    component: () => import('@/views/DealerAppraisalStep4Page.vue'),
    meta: { title: '지점 감정' }
  },
  {
    path: '/dealer-appraisal/step5',
    name: 'DealerAppraisalStep5',
    component: () => import('@/views/DealerAppraisalStep5Page.vue'),
    meta: { title: '지점 감정' }
  },

  // 06. 계좌관리
  {
    path: '/account/step1',
    name: 'AccountStep1',
    component: () => import('@/views/AccountStep1Page.vue'),
    meta: { title: '계좌관리' }
  },
  {
    path: '/account/step2',
    name: 'AccountStep2',
    component: () => import('@/views/AccountStep2Page.vue'),
    meta: { title: '계좌관리' }
  },
  {
    path: '/auth/verify/start',
    name: 'AuthVerifyStart',
    component: () => import('@/views/AuthVerifyStartPage.vue'),
    meta: { title: '본인인증' }
  },
  {
    // NICE 본인인증에서 돌아오는 자리. 공용 서버의 돌아갈 주소 허용 목록에 이 출처가 있어야 한다.
    path: '/auth/verify/done',
    name: 'AuthVerifyDone',
    component: () => import('@/views/AuthVerifyDonePage.vue'),
    meta: { title: '본인인증' }
  },
  {
    path: '/account/step3',
    name: 'AccountStep3',
    component: () => import('@/views/AccountStep3Page.vue'),
    meta: { title: '계좌관리' }
  },
  {
    path: '/account/step3-2',
    name: 'AccountStep3_2',
    component: () => import('@/views/AccountStep3_2Page.vue'),
    meta: { title: '계좌관리' }
  },
  {
    path: '/account/step5',
    name: 'AccountStep5',
    component: () => import('@/views/AccountStep5Page.vue'),
    meta: { title: '계좌관리' }
  },

  // 07. 입금하기
  {
    path: '/deposit',
    name: 'Deposit',
    component: () => import('@/views/DepositPage.vue'),
    meta: { title: '입금하기' }
  },
  {
    path: '/deposit/step2',
    name: 'DepositStep2',
    component: () => import('@/views/DepositStep2Page.vue'),
    meta: { title: '입금하기' }
  },

  // 08. 출금 · 결제
  {
    path: '/withdraw',
    name: 'Withdraw',
    component: () => import('@/views/WithdrawPage.vue'),
    meta: { title: '출금하기' }
  },
  {
    path: '/payment-password',
    name: 'PaymentPassword',
    component: () => import('@/views/PaymentPasswordPage.vue'),
    meta: { title: '결제 비밀번호' }
  },
  {
    path: '/payment-password/new',
    name: 'PaymentPasswordNew',
    component: () => import('@/views/PaymentPasswordNewPage.vue'),
    meta: { title: '신규 결제 비밀번호' }
  },
  {
    path: '/payment-password/new-confirm',
    name: 'PaymentPasswordNewConfirm',
    component: () => import('@/views/PaymentPasswordNewConfirmPage.vue'),
    meta: { title: '신규 결제 비밀번호 확인' }
  },
  {
    path: '/payment-password/old',
    name: 'PaymentPasswordOld',
    component: () => import('@/views/PaymentPasswordOldPage.vue'),
    meta: { title: '이전 결제 비밀번호' }
  },

  // 09. 내역
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/HistoryPage.vue'),
    meta: { title: '내역' }
  },
  {
    path: '/history/detail',
    name: 'HistoryDetail',
    component: () => import('@/views/HistoryDetailPage.vue'),
    meta: { title: '내역 상세' }
  },
  {
    path: '/history/detail-1',
    name: 'HistoryDetail1',
    component: () => import('@/views/HistoryDetail1Page.vue'),
    meta: { title: '내역 상세' }
  },
  {
    path: '/history/type',
    name: 'HistoryType',
    component: () => import('@/views/HistoryTypePage.vue'),
    meta: { title: '내역' }
  },
  {
    path: '/history/filter',
    name: 'HistoryFilter',
    component: () => import('@/views/HistoryFilterPage.vue'),
    meta: { title: '조회 옵션' }
  },
  {
    path: '/history/order',
    name: 'HistoryOrder',
    component: () => import('@/views/HistoryOrderPage.vue'),
    meta: { title: '주문 내역' }
  },
  {
    path: '/history/order-book',
    name: 'HistoryOrderBook',
    component: () => import('@/views/HistoryOrderBookPage.vue'),
    meta: { title: '호가창 거래' }
  },
  {
    path: '/history/order-detail',
    name: 'HistoryOrderDetail',
    component: () => import('@/views/HistoryOrderDetailPage.vue'),
    meta: { title: '주문 상세' }
  },
  {
    path: '/history/product-purchase',
    name: 'HistoryProductPurchase',
    component: () => import('@/views/HistoryProductPurchaseDetailPage.vue'),
    meta: { title: '상품 구매 · 인출' }
  },
  {
    path: '/history/filter-option',
    name: 'HistoryFilterOption',
    component: () => import('@/views/HistoryFilterOptionPage.vue'),
    meta: { title: '조회 옵션' }
  },

  // 10. 내 정보 수정
  {
    path: '/my-info',
    name: 'MyInfo',
    component: () => import('@/views/MyInfoPage.vue'),
    meta: { title: '내 정보 수정' }
  },

  // 11. 공지사항 · 자주 묻는 질문 (board: NOTICE / FAQ)
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('@/views/NoticePage.vue'),
    meta: { title: '공지사항' }
  },
  {
    path: '/notice/:boardCode',
    name: 'NoticeDetail',
    component: () => import('@/views/BoardDetailPage.vue'),
    meta: { title: '공지사항', boardType: 'NOTICE', listPath: '/notice' }
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import('@/views/FaqPage.vue'),
    meta: { title: '자주 묻는 질문' }
  },
  {
    path: '/faq/:boardCode',
    name: 'FaqDetail',
    component: () => import('@/views/BoardDetailPage.vue'),
    meta: { title: '자주 묻는 질문', boardType: 'FAQ', listPath: '/faq' }
  },

  // 12. 보관료
  {
    path: '/storage-fee',
    name: 'StorageFee',
    component: () => import('@/views/StorageFeePage.vue'),
    meta: { title: '보관료' }
  },

  // 13. 1:1 문의
  {
    path: '/inquiry',
    name: 'Inquiry',
    component: () => import('@/views/InquiryPage.vue'),
    meta: { title: '1:1 문의' }
  },
  {
    path: '/assets-ai',
    name: 'AssetsAi',
    component: () => import('@/views/AssetsAiPage.vue'),
    meta: { title: '자산관리 AI' }
  },
  /** 설문 마지막 "상담 요청하기" 진입용 — 1:1 문의와 동일 화면, 헤더만 처음으로+제목 전환 */
  {
    path: '/survey/consult',
    redirect: { path: '/inquiry', query: { entry: 'survey' } }
  },

  // 14. 비밀번호 변경
  {
    path: '/change-password/current',
    name: 'ChangePasswordCurrent',
    component: () => import('@/views/ChangePasswordCurrentPage.vue'),
    meta: { title: '비밀번호 변경' }
  },
  {
    path: '/change-password/new',
    name: 'ChangePasswordNew',
    component: () => import('@/views/ChangePasswordNewPage.vue'),
    meta: { title: '비밀번호 변경' }
  },
  {
    path: '/change-password/confirm',
    name: 'ChangePasswordConfirm',
    component: () => import('@/views/ChangePasswordConfirmPage.vue'),
    meta: { title: '비밀번호 변경' }
  }
]

const router = createRouter({
  history: createWebHistory(base),
  routes
})

/**
 * 새 배포 뒤 옛 화면 조각을 못 받으면 그 주소를 새로 연다.
 *
 * 화면은 조각(`() => import(...)`)으로 나뉘어 있고 파일 이름에 빌드 해시가 붙는다. 배포하면
 * 옛 조각은 서버에서 사라지는데(404), 그 전에 열어 둔 탭은 옛 목록을 들고 있다. 그 탭에서
 * 아직 안 받은 화면으로 가면 import 가 실패해 **이동이 통째로 취소된다** — 2026-11-01 에
 * 로그아웃이 로그인 화면으로 안 넘어가고 새로고침해야 넘어갔다. 앱(WebView)은 오래 켜 두니
 * 배포 때마다 겪는다.
 *
 * 같은 주소로 30초 안에 또 실패하면 다시 열지 않는다(조각이 정말 없는 경우 무한 새로고침 방지).
 */
const CHUNK_RELOAD_KEY = 'aura_chunk_reload'
const CHUNK_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i

router.onError((error, to) => {
  if (!CHUNK_ERROR.test(String(error?.message || ''))) return
  const target = to?.fullPath || `${window.location.pathname}${window.location.search}`
  try {
    const last = JSON.parse(window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 'null')
    if (last && last.target === target && Date.now() - last.at < 30000) return
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, JSON.stringify({ target, at: Date.now() }))
  } catch (_e) {
    // sessionStorage 를 못 쓰면 막는 장치 없이 한 번 연다.
  }
  window.location.assign(target)
})

const PUBLIC_PATHS = new Set([
  '/intro',
  // 미리보기는 로그인 상태에서도 봐야 한다 - 아래 '/intro' 튕김 분기에는 넣지 않는다.
  '/intro-preview',
  '/login',
  '/login/sns/google',
  '/login/sns/apple',
  '/login/sns/kakao',
  '/login/sns/naver',
  '/pages_link',
  '/join/step1',
  '/join/step2',
  '/vvip',
  '/vvip/service'
])

const DEALER_FLOW_REQUIRED_PATHS = new Set([
  '/dealer-appraisal/step2',
  '/dealer-appraisal/step3',
  '/dealer-appraisal/step4',
  '/dealer-appraisal/step5'
])

const RECOMMENDED_BRANCH_PATH = '/join/recommended-branch'

/**
 * 본인인증을 마친 회원만 들어오는 화면. 입출금 계좌는 본인 명의만 등록하고 NICE 로 소유주를 확인하므로
 * 인증 전에는 아예 못 들어온다(2026-11-01 지시). 계좌 화면 안에서 인증을 띄우지 않는다.
 * 출금도 같다 — 확인된 출금계좌로만 받는다(2026-11-01 결정).
 * '인증됨' 은 /me 의 verified 다 — 서버가 생년월일까지 있어야 true 를 준다.
 */
const IDENTITY_REQUIRED_PATHS = new Set([
  '/account/step1',
  '/account/step2',
  '/account/step3',
  '/account/step3-2',
  '/account/step5',
  '/withdraw'
])

function normalizePath(path) {
  if (!path || path === '/') return '/'
  return path.endsWith('/') ? path.slice(0, -1) : path
}

function isPublicPath(path) {
  const normalized = normalizePath(path)
  return PUBLIC_PATHS.has(normalized)
}

function isAuthenticated() {
  return hasAccessToken()
}

async function isRecommendedBranchRequired() {
  try {
    const result = await fetchMe()
    return result?.code === 0 && result?.data?.recommendedBranchRequired === true
  } catch (_error) {
    return false
  }
}

/** 확인하지 못하면 막는다 — 들어간 뒤에 서버가 막는 것보다 처음부터 인증 화면으로 보내는 편이 낫다. */
async function isIdentityVerified() {
  try {
    const result = await fetchMe()
    return result?.code === 0 && result?.data?.verified === true
  } catch (_error) {
    return false
  }
}

function isJoinRoutesBackBlocked() {
  try {
    if (typeof window === 'undefined') return false
    const value = window.sessionStorage?.getItem(JOIN_ROUTES_BACK_BLOCK_KEY)
    return value === '1'
  } catch (_e) {
    return false
  }
}

router.beforeEach(async (to, _from, next) => {
  // 웹의 본인인증 팝업이 NICE 를 거쳐 돌아왔다 - 화면을 그리기 전에 결과를 원래 창에 넘기고 닫는다
  // (utils/identity-popup). 로그인 확인보다 먼저 해야 팝업이 로그인 화면으로 새지 않는다.
  // 원래 창이 받았다고 답하지 않으면(같은 창 흐름) 그대로 이 창에서 마무리한다.
  if (normalizePath(to.path) === '/auth/verify/done' && to.query.state && to.query.from !== 'popup' && !isFlutterApp()) {
    if (await handOverIdentityReturn(pickIdentityQuery(to.query))) {
      closeIdentityPopup()
      next(false)
      return
    }
  }

  const appTitle = import.meta.env.VITE_APP_TITLE || 'REAL GOLD TRADE'
  const entry = String(to.query?.entry || '').toLowerCase()
  const inquirySurvey =
    normalizePath(to.path) === '/inquiry' && (entry === 'survey' || entry === 'consult')
  const pageTitle = inquirySurvey ? '상담 요청하기' : to.meta.title
  document.title = pageTitle ? `${pageTitle} - ${appTitle}` : appTitle

  const authenticated = isAuthenticated()
  const normalizedToPath = normalizePath(to.path)

  /* 가입 마지막(complete→home) 이후 뒤로가기로 step3/complete 등 /join/* 재진입 방지 */
  if (
    isJoinRoutesBackBlocked()
    && normalizedToPath.startsWith('/join/')
    && normalizedToPath !== RECOMMENDED_BRANCH_PATH
  ) {
    next({ path: '/home', replace: true })
    return
  }

  if (authenticated && normalizedToPath === '/login') {
    next('/home')
    return
  }

  if (authenticated && normalizedToPath === '/intro') {
    next('/home')
    return
  }

  if (isPublicPath(to.path)) {
    next()
    return
  }

  if (!authenticated) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  if (normalizedToPath !== RECOMMENDED_BRANCH_PATH && await isRecommendedBranchRequired()) {
    next({
      path: RECOMMENDED_BRANCH_PATH,
      query: { redirect: to.fullPath },
      replace: true
    })
    return
  }

  if (IDENTITY_REQUIRED_PATHS.has(normalizedToPath) && !(await isIdentityVerified())) {
    next({
      path: '/auth/verify/start',
      query: { redirect: to.fullPath },
      replace: true
    })
    return
  }

  if (DEALER_FLOW_REQUIRED_PATHS.has(normalizedToPath) && !hasDealerAppraisalFlow()) {
    next('/dealer-appraisal/step1')
    return
  }

  next()
})

export default router
